import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './tufts-heading.css.lit';
import { html } from 'lit/static-html.js';
import { classMap } from 'lit/directives/class-map.js';
import resolvedTailwindConfig from '../../../resolved-tailwind-config';
import { CSSResultArray } from 'lit';
import { SlotNGController } from '../../controllers/slot-ng-controller';

export type AllowedHeadingSizes = keyof typeof resolvedTailwindConfig.fontSize;
export type AllowedHeadingStyles =
  keyof typeof resolvedTailwindConfig.fontWeight;

/**
 * The Tufts Heading
 * @element tufts-heading
 *
 * @slot - A default slot
 *
 * @attr level-size
 * @attr text-color
 * @attr page-headings
 * @attr clickable-card
 */
@customElement('tufts-heading')
export class TuftsHeading extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  ngSlot = new SlotNGController(this);

  @property({ type: String, reflect: true, attribute: 'level-size' })
  levelSize: AllowedHeadingSizes;

  @property({ type: String, reflect: true, attribute: 'text-color' })
  textColor: string;

  @property({ type: Boolean, reflect: true, attribute: 'page-headings' })
  pageHeadings = false;

  @property({ type: Boolean, reflect: true, attribute: 'clickable-card' })
  clickableCard = false;

  connectedCallback() {
    super.connectedCallback();
  }

  render() {
    const classes = {
      [`${this.levelSize}`]: !!this.levelSize,
      [`${this.textColor}`]: !!this.textColor,
      'page-headings': !!this.pageHeadings,
      'clickable-card': !!this.clickableCard,
    };

    return html`
      <div class="${classMap(classes)}">${this.ngSlot.renderInShadow()}</div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'tufts-heading': TuftsHeading;
  }
}
